module.exports = __webpack_public_path__ + "img/type_GRASS.06bec833.png";